import type { AddressGuest } from '@/modules/cart/domain/AddressGuest';
import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const SHIPPING_ADDRESS_URL = `${CART_URL}/shipping-address`;

export async function createShippingAddressForGuest(
  address: Omit<AddressGuest, 'id'>
): Promise<{ data: HttpCartDto }> {
  return await httpClient.post(SHIPPING_ADDRESS_URL, {
    ...address,
    country: 'CL',
    region: address.region + ''
  });
}
